export default __webpack_public_path__ + "static/media/profile-settings.72ec07d6.svg";